(function () {
  'use strict';
  class Controller {
    constructor() {}
  }
  angular
    .module('approval.updateSite', [])
    .component('approvalUpdateSite', {
      controller: Controller,
      templateUrl: 'root/approval/_components/updateSite/updateSite-approval.comp.html',
      bindings: {}
    });
}());
